<template>
  <TsCard id="trustpilot-review"
          data-testid="trustpilot-review"
          no-shadow
          append-class="mb-6 lg:row px-4 py-3 w-full"
          body-class="column mt-auto"
          footer-class="pt-0 column mt-auto"
  >
    <template #content>

      <TsRow class="w-full">
        <TsTrustpilot template-id="5613c9cde69ddc09340c6beb" />
      </TsRow>

      <TsRow isMultiline no-gutter >
        <TsColumn class="lg:is-5 is-12 ">
          <TsTypography
              as="h3"
              append-class="mb-4 ml-8 mt-5 w-full font-semibold"
          >
            {{ useTranslation('rateRecentExp', 'Beoordeel uw recente ervaring') }}
          </TsTypography>
        </TsColumn>

        <TsRow no-gutter appendClass="mx-auto">
        </TsRow>
      </TsRow>


    </template>
    <template #footer>
      <TsRow isMultiline no-gutter class="gap-2 lg:mt-0 mt-5">
        <TsColumn appendClass="lg:block hidden"></TsColumn>
        <TsColumn class="lg:is-4  max-sm:is-12">
        </TsColumn>
        <TsColumn class="lg:is-4 max-sm:is-12">
          <TsButton
              link="https://www.trustpilot.com/review/www.toolstation.nl?utm_medium=trustbox&utm_source=Mini"
              :label="useTranslation('writeAReview', 'Schrijf een recensie')"
              variant="success"
              linkTarget="_blank"
              outlined
              block
          />
        </TsColumn>
      </TsRow>
    </template>
  </TsCard>



</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsTrustpilot = defineAsyncComponent(
    () => import('~/components/organisms/TsTrustpilot.vue')
);
</script>
